
import ModuleFactory from "./utilities/module-factory";
import Header from "./header";
import Hero from "./elements/hero";
import Video from "./elements/video";
import VideoSlider from "./elements/video-slider";
import Reviews from "./elements/reviews";
import Cards from "./elements/cards";
import Banner from "./elements/banner";
import Faqs from "./elements/faqs";
import Information from "./elements/information";
import FeaturedRoles from "./elements/featured-roles";
import FeaturedEvents from "./elements/featured-events";
import Album from "./elements/album";
import Map from "./elements/map";
import List from "./elements/list";
import Timeline from "./elements/timeline";
import BlogListing from "./blog";
import InformationSlider from "./elements/information-slider";
import ServicesCalculator from "./services-calculator";
import MembersSlider from "./elements/members-slider";
import CareersListing from "./elements/careers-listing";
import BlogCategorySlider from "./elements/blog-category-slider";

const modules = [
	Header,
	Hero,
	Video,
	VideoSlider,
	Reviews,
	Cards,
	CareersListing,
	Banner,
	Faqs,
	Information,
	FeaturedRoles,
	FeaturedEvents,
	List,
	Album,
	Map,
	Timeline,
	BlogListing,
	InformationSlider,
	ServicesCalculator,
	MembersSlider,
	BlogCategorySlider,
];

new ModuleFactory(modules);

